export const COPY_RIGHT = "Copyright(c) インサイトinc. All rights reserved."
